import { inject, Injectable, signal } from '@angular/core';
import { SocketService } from '@core/services/socket.service';

interface PinnedMessage {
  time: number;
  message: string;
}

const PINNED_MESSAGE_TIMESTAMP_KEY = 'tf2_pinned_message_timestamp';
const PINNED_MESSAGE_IS_HIDDEN_KEY = 'tf2_pinned_message_is_hidden';

@Injectable({
  providedIn: 'root',
})
export class PinnedMessageService {
  private readonly socketService = inject(SocketService);

  pinnedMessage = signal<PinnedMessage | null>(null);
  isAlwaysHidePinnedMessage = signal<boolean>(false);

  constructor() {
    this.connectPinnedMessage();
  }

  private connectPinnedMessage() {
    const hiddenRaw = localStorage.getItem(PINNED_MESSAGE_IS_HIDDEN_KEY);
    const hidden =
      hiddenRaw === null || hiddenRaw === 'undefined'
        ? false
        : JSON.parse(hiddenRaw);

    const timeRaw = localStorage.getItem(PINNED_MESSAGE_TIMESTAMP_KEY);
    const time =
      timeRaw === null || timeRaw === 'undefined' ? 0 : JSON.parse(timeRaw);
    this.isAlwaysHidePinnedMessage.set(hidden);

    this.socketService.socket.on('pinned_message', (data: PinnedMessage) => {
      this.pinnedMessage.set(data);
      this.setLocalStorageTimestamp(data.time ?? 'none');

      if (time !== data.time && hidden) {
        this.setLocalStorageIsHidden(false);
        this.isAlwaysHidePinnedMessage.set(false);
      }
    });
  }

  private setLocalStorageIsHidden(value: boolean) {
    localStorage.setItem(PINNED_MESSAGE_IS_HIDDEN_KEY, JSON.stringify(value));
  }

  private setLocalStorageTimestamp(value: number) {
    localStorage.setItem(PINNED_MESSAGE_TIMESTAMP_KEY, JSON.stringify(value));
  }

  public alwaysHidePinnedMessage() {
    this.setLocalStorageIsHidden(true);
    this.isAlwaysHidePinnedMessage.set(true);
  }
}
